import { RefreshCw, Undo2, Calendar, MessageCircle } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setPage } from '../../Redux/store';

function MatchEmpty({ loading, onReset, onCheckMore, exhausted }) {
  const dispatch = useDispatch();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center">
      <h2 className="text-lg font-semibold">
        You're all caught up
      </h2>
      <p className="text-sm text-muted-foreground">
        All matches sorted for now.
      </p>
      <div className="mt-4 flex flex-col gap-2">
        <button
          className="flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground disabled:opacity-50"
          onClick={onCheckMore}
          disabled={loading}
        >
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          {loading ? 'Checking' : 'Check for More'}
        </button>
        <button
          className="flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-medium text-foreground disabled:opacity-50"
          onClick={onReset}
          disabled={loading}
        >
          <Undo2 size={16} />
          Reset All Passes
        </button>
        <button
          className="flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-medium text-foreground"
          onClick={() => dispatch(setPage('calendar'))}
        >
          <Calendar size={16} />
          View Calendar
        </button>
        <button
          className="flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-medium text-foreground"
          onClick={() => dispatch(setPage('chats'))}
        >
          <MessageCircle size={16} />
          View Chats
        </button>
      </div>
    </div>
  );
}

export default MatchEmpty;
